<template>
  <div>
    <div class="artcol_top_bar">
      <span class="artcol_tip" @click="goTome">个人中心</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="user_infor_con">
      <div class="user_infor_con_left">
        <el-avatar shape="square" :src="avatarCalc"></el-avatar>
        <div class="infor_container">
          <span class="uname_btn">{{ this.userInfo.name }}</span>
          <span class="phone_txt">{{ this.maskPhoneNumber }}</span>
        </div>
        <el-button
          type="primary"
          circle
          icon="el-icon-edit"
          @click="showUserInfoDialog = true"
        ></el-button>
      </div>

      <!-- <span class="setting_btn" @click="settingsDialogVisible = true">设置</span> -->
    </div>

    <div class="static_con">
      <div class="ucol_con">
        <div class="col_img_con">
          <img src="../assets/colimg.png" class="col_img" />
        </div>
        <div class="col_static_con">
          <span class="col_static_txt">{{ num_col }}</span>
          <span class="col_static_label">收藏</span>
        </div>
      </div>

      <div class="uup_con">
        <div class="up_img_con">
          <img src="../assets/up_img.png" class="up_img" />
        </div>
        <div class="up_static_con">
          <span class="up_static_txt">{{ num_upload }}</span>
          <span class="up_static_label">上传</span>
        </div>
      </div>

      <div class="ufri_con">
        <div class="fri_img_con">
          <img src="../assets/fri.png" class="fri_img" />
        </div>
        <div class="fri_static_con">
          <span class="fri_static_txt">{{ num_friend }}</span>
          <span class="fri_static_label">好友</span>
        </div>
      </div>

      <div class="usou_con">
        <div class="sou_img_con">
          <img src="../assets/sou.png" class="sou_img" />
        </div>
        <div class="sou_static_con">
          <span class="sou_static_txt">{{ num_sourse }}</span>
          <span class="sou_static_label">来源</span>
        </div>
      </div>
    </div>

    <div class="me_btns_con">
      <div class="me_btn_item" @click="artmag">
        <div class="me_btn_item_top">文章管理</div>
        <div class="me_btn_item_bottom">ARTICLE</div>
      </div>
      <div class="me_btn_item" @click="clsmag">
        <div class="me_btn_item_top">分类管理</div>
        <div class="me_btn_item_bottom">CLASSIFICATION</div>
      </div>
      <div class="me_btn_item" @click="sharemag">
        <div class="me_btn_item_top">分享管理</div>
        <div class="me_btn_item_bottom">SHARE</div>
      </div>
      <div class="me_btn_item" @click="friends">
        <div class="me_btn_item_top">我的好友</div>
        <div class="me_btn_item_bottom">FRIENDS</div>
      </div>
      <div class="me_btn_item">
        <div class="me_btn_item_top" @click="feedback">反馈</div>
        <div class="me_btn_item_bottom">FEEDBACK</div>
      </div>
    </div>

    <settings :dialogVisible.sync="settingsDialogVisible"></settings>
    <div v-if="showUserInfoDialog" class="user-info-dialog">
      <div class="dialog-content">
        <h3>修改个人信息</h3>
        <h4>头像</h4>

        <el-upload
          class="upload-demo"
          accept=".jpg,.png,"
          drag
          :action="upload_url"
          :before-upload="beforeUpload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          multiple
          :limit="1"
          :headers="dynamicHeaders"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">请上传jpg、png文件</div>
          <div class="el-upload__tip" slot="tip"></div>
        </el-upload>

        <h4>用户名</h4>
        <input
          type="text"
          v-model="userName"
          :placeholder="this.userInfo.name"
          class="small-input"
        />
        <button @click="updateUserInfo">更新</button>
        <button @click="showUserInfoDialog = false">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  articleCollect,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
  getColNum,
  getUploadNum,
  getSourcesNum,
} from "@/api/article";
import { GetFriendList, getFriendsByUseridAndKey } from "@/api/friend";
import { updateUserName, updateImage } from "@/api/user";
import { url } from "@/api/request";
import settings from "@/components/me/settings";
export default {
  name: "me",
  components: {
    settings,
  },
  data() {
    return {
      // 这个userName只用于修改昵称
      userName: null,

      download: 0,
      upload: 0,
      defaultAvatar:
        "https://img-qn.51miz.com/Element/00/88/08/84/72f298b9_E880884_d0f63115.png",
      num_friend: 0,
      num_col: 0,
      num_upload: 0,
      num_sourse: 0,
      // settings dialog
      settingsDialogVisible: false,
      showUserInfoDialog: false, // 控制对话框显示的属性
      upload_url: `${url}/api/kp/user/startUploadImage`,
      dynamicHeaders: null,
      fileList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    avatarCalc() {
      return this.userInfo.avatar || this.defaultAvatar;
    },
    downloadNum() {
      return this.userInfo.download || 0;
    },
    uploadNum() {
      return this.userInfo.upload || 0;
    },
    uploadData() {
      return {
        userName: this.userName,
      };
    },
    maskPhoneNumber() {
      const phone = this.userInfo.phone;
      const phoneString = String(phone);
      if (phoneString && typeof phoneString === "string") {
        const maskedPhone =
          phoneString.substring(0, 3) + "****" + phoneString.substring(7);
        return maskedPhone;
      } else {
        return "null";
      }
    },
  },
  mounted() {
    if (this.userInfo.id == null) {
      this.$store.dispatch("WhoAmI");
    }
    this.userName = this.userInfo.name;
    this.dynamicHeaders = {
      Authorization: "Bearer " + localStorage.getItem("token"),
    };
    this.getFriNum();
    this.getColNum();
    this.getUploadNum();
    this.getSourcesNum();
    console.log("this.userInfo", this.userInfo);
  },
  methods: {
    beforeUpload(file) {
      var fileName = file.name;

      var fileType = fileName.substring(fileName.lastIndexOf("."));
      if (fileType !== ".jpg" && fileType !== ".png") {
        this.$message.error({
          message: `请上传jpg/png文件！`,
        });
        return false;
      }

      this.loading = this.$loading({
        lock: true,
        text: "正在上传头像...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        target: ".main_right",
      });
    },

    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
      this.loading.close();
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
    clsmag() {
      var that = this;

      that.$router.push({ name: "clsmag", params: { refresh: true } });
    },
    artmag() {
      var that = this;

      that.$router.push({ name: "artmag", params: { refresh: true } });
    },
    friends() {
      var that = this;

      that.$router.push({ name: "friends", params: { refresh: true } });
    },
    sharemag() {
      var that = this;

      that.$router.push({ name: "sharemag", params: { refresh: true } });
    },
    feedback() {
      var that = this;

      that.$router.push({ name: "feedback", params: { refresh: true } });
    },
    getFriNum() {
      var that = this;
      GetFriendList()
        .then((response) => {
          that.num_friend = response.data.length; // 使用搜索结果更新列表
        })
        .catch((error) => {
          console.error("好友好友数量报错:", error);
        });
    },
    getColNum() {
      var that = this;
      getColNum()
        .then((response) => {
          console.log(response);
          that.num_col = response.data;
        })
        .catch((error) => {
          console.error("收藏数量报错:", error);
        });
    },
    getUploadNum() {
      var that = this;
      getUploadNum()
        .then((response) => {
          console.log(response);
          that.num_upload = response.data;
        })
        .catch((error) => {
          console.error("上传数量报错:", error);
        });
    },
    getSourcesNum() {
      var that = this;
      getSourcesNum()
        .then((response) => {
          console.log(response);
          that.num_sourse = response.data;
        })
        .catch((error) => {
          console.error("来源数量报错:", error);
        });
    },
    updateUserName() {
      // 调用修改用户名的接口
      updateUserName({ userName: this.userName })
        .then((response) => {
          this.refreshUserInfo();
        })
        .catch((error) => {
          // 处理错误
          console.log(error);
          console.log("修改用户名失败");
        });
    },

    uploadImage() {
      // 调用上传图片的接口
      updateImage()
        .then((response) => {
          // 处理响应
          console.log("上传图片成功");
          this.refreshUserInfo();
        })
        .catch((error) => {
          // 处理错误
          console.log("上传图片失败");
        });
    },
    refreshUserInfo() {
      this.$store.dispatch("WhoAmI");
    },
    updateUserInfo() {
      if (this.userName && this.fileList.length > 0) {
        // 如果同时修改了用户名和上传了文件
        this.updateUserName();
        this.uploadImage();
      } else if (this.userName) {
        // 只修改了用户名
        this.updateUserName();
      } else if (this.fileList.length > 0) {
        // 只上传了文件
        this.uploadImage();
      }

      this.fileList = [];
      this.userName = null;
      this.showUserInfoDialog = false;
    },
  },
};
</script>

<style>
.me_btn_item_bottom {
  color: white;
  font-size: 14px;
  margin-top: 15px;
}

.me_btn_item_top {
  color: white;
  font-size: 24px;
}

.me_btn_item {
  margin-left: 10px;
  margin-right: 10px;
  background-color: #50a2f6;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  flex: 1;
  cursor: pointer;
}

.me_btn_item:hover {
  background-color: #2d64b3;
}

.me_btns_con {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.sou_static_label {
  color: #5ba1f0;
  font-size: 18px;
  display: block;
}

.sou_static_txt {
  color: #5ba1f0;
  font-size: 24px;
}

.sou_static_con {
  margin-left: 8px;
}

.sou_img {
  width: 30px;
  height: 30px;
}

.sou_img_con {
  width: 54px;
  height: 54px;
  background-color: #5ba1f0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.usou_con {
  flex: 1;
  background: rgb(12, 133, 249, 0.1);
  /* //opacity: 0.5; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.fri_static_label {
  color: #5dd7f1;
  font-size: 18px;
  display: block;
}

.fri_static_txt {
  color: #5dd7f1;
  font-size: 24px;
}

.fri_static_con {
  margin-left: 8px;
}

.fri_img {
  width: 30px;
  height: 30px;
}

.fri_img_con {
  width: 54px;
  height: 54px;
  background-color: #5dd7f1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ufri_con {
  flex: 1;
  background: rgb(50, 203, 236, 0.1);
  /* //opacity: 0.5; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.up_static_label {
  color: #8ca9f2;
  font-size: 18px;
  display: block;
}

.up_static_txt {
  color: #8ca9f2;
  font-size: 24px;
}

.up_static_con {
  margin-left: 8px;
}

.up_img {
  width: 30px;
  height: 30px;
}

.up_img_con {
  width: 54px;
  height: 54px;
  background-color: #8ca9f2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uup_con {
  flex: 1;
  background: rgb(50, 103, 236, 0.1);
  /* //opacity: 0.5; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.col_static_label {
  color: #5ba1f0;
  font-size: 18px;
  display: block;
}

.col_static_txt {
  color: #5ba1f0;
  font-size: 24px;
}

.col_static_con {
  margin-left: 8px;
}

.col_img {
  width: 30px;
  height: 30px;
}

.col_img_con {
  width: 54px;
  height: 54px;
  background-color: #5ba1f0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ucol_con {
  flex: 1;
  background: rgb(12, 133, 249, 0.1);
  /* //opacity: 0.5; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-left: 10px;
  margin-right: 10px;
}

.static_con {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.setting_btn {
  color: #5ba1f0;
  font-size: 26px;
  margin-right: 30px;
  cursor: pointer;
}

.phone_txt {
  color: #5ba1f0;
  font-size: 14px;
  display: block;
  margin-top: 3px;
}
.uname_txt {
  font-size: 26px;
  color: #5ba1f0;
}

.uimg {
  width: 58px;
  height: 58px;
  border-radius: 50%;
}

.infor_container {
  margin-left: 20px;
  margin-right: 20px;
}

.user_infor_con_left {
  display: flex;
  align-items: center;
}

.user_infor_con {
  background-color: #d2e0f6;
  border-radius: 10px;
  padding: 15px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.artcol_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artcol_top_bar {
  display: flex;
  align-items: center;
}
.user-info-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.dialog-content h3 {
  margin-bottom: 15px;
}

.dialog-content input[type="text"] {
  display: block;
  margin-bottom: 10px;
  width: 90%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.dialog-content button {
  margin-right: 10px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.add_in_con1 {
  width: 100%;
}
.small-input {
  width: 50px; /* 调整宽度至所需的尺寸 */
}
</style>
